import { Component, OnInit, ViewChild } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { LoginService } from 'src/app/services/login/login.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { ProgressingComponent } from '../progressing/progressing.component';

@Component({
  selector: 'app-guest-player-toc',
  templateUrl: './guest-player-toc.component.html',
  styleUrls: ['./guest-player-toc.component.scss'],
})
export class GuestPlayerTocComponent implements OnInit {
  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

  public generatedCSRF;
  public storeServerCSRFToken;
  public error: any = null;
  public featureTermsAndConditionURL: string;
  public featurePrivacyURL: string;
  public disableGuestBtn: boolean = false;

  constructor(
    private navigator: Navigator,
    private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private galleryService: GalleryService,
    private userSessionService: UserSessionService,
    private eventService: EventsService,
    private appLinks: AppLinksService,
    private config: ConfigService,
    private eventsService: EventsService,
    private appStorageService: AppstorageTsService

  ) { }

  ngOnInit() {
    this.featureTermsAndConditionURL = this.config.getConfig().FEATURE_SITE_TERMS_LINK;
    this.featurePrivacyURL = this.config.getConfig().FEATURE_SITE_PRIVACY_LINK;
  }

  closeTOC() {
    this.navigator.dismiss();
  }

  doPlayAsGuestCall() {
    this.disableGuestBtn = true;
    this.setUserPlatformIDInfo();
  }

  generateCSRFToken() {
    return new Promise((resolve, reject) => {
      this.authenticationService.getCsrfToken().subscribe(
        (response) => {
          if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
            this.generatedCSRF = response.payload.token;
            resolve(this.generatedCSRF);
          }
        }
      )
    })
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

  async setUserPlatformIDInfo() {
    const csrf: any = await this.generateCSRFToken();
    this.authenticationService.callGuestAccountSignup(csrf, true).subscribe(
      (response) => {
        if (!isUndefined(response.payload)) {
          this.appStorageService.setPlayerPlatformID(response.payload.platformId);
          this.storeServerCSRFToken = response.payload.csrf_token;
          this.appStorageService.getPlayerPlatformID().then((id) => {
            const playerData: any = {
              platform_id: id.value,
              csrf: this.storeServerCSRFToken
            }
            this.callGuestAccountLogin(playerData)
          })

        }
      },
      error => {
        switch (error.getErrorCode().toUpperCase()) {
          default:
            error.setErrorMessage('An error has occured logging you in. Please try again.');
            break;
        }
        this.error = error;
      }
    );
  }

  callGuestAccountLogin(data) {
    const apiCall$ = this.authenticationService.callUniversalLogin(data);
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe(
      (response) => {
        if (!isUndefined(response.payload)) {
          this.loginService.setCustomerID(response.payload.customerId);
          this.appStorageService.setPlayerPlatformID(response.payload.platformId);
          this.appStorageService.setPlayerAsGuest(true);
          this.userSessionService.setSessionToken(response.payload.sessionToken);
          this.userSessionService.refreshCustomer().subscribe(() => {
            let params = {}
            this.eventsService.publish('event:appInit:init', params);
          });
          this.navigator.dismissAll();
          this.eventService.publish('show:welcome:dialog');
          this.galleryService.getGameList();
          this.disableGuestBtn = false;
        }
      }, error => {
        this.disableGuestBtn = false;
        switch (error.getErrorCode().toUpperCase()) {
          default:
            error.setErrorMessage('An error has occured logging you in. Please try again.');
            break;
        }
        this.error = error;
      }
    )
  }

}
